/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class McpServerSetEnabledRequest {
    getFixupPrototypeFunction() { return McpServerSetEnabledRequest.fixupPrototype; }

    static newInstance(model: Partial<McpServerSetEnabledRequest>): McpServerSetEnabledRequest {
        let obj = Object.assign(new McpServerSetEnabledRequest(), model);
        McpServerSetEnabledRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<McpServerSetEnabledRequest>): McpServerSetEnabledRequest {
        if (!model) return null;
        return McpServerSetEnabledRequest.newInstance(<McpServerSetEnabledRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: McpServerSetEnabledRequest) {
        if (!obj) return;

        models.McpServerSetEnabledRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: McpServerSetEnabledRequest): boolean {
        Object.setPrototypeOf(obj, McpServerSetEnabledRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Set to true to enable the server, false to disable.
     */
    is_enabled: boolean;

}
